import PropTypes from "prop-types"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { cn } from "styles/utils"

const ConfettiCard = ({ children, className, icon, iconClassName, title }) => {
  return (
    <div className={cn("desktop:px-40 desktop:py-44 border-2 p-16", className)}>
      <div className="desktop:mb-20 mb-10 flex items-center">
        <FontAwesomeIcon
          className={cn(
            "text-24 desktop:text-32 desktop:mr-20 mr-8",
            iconClassName
          )}
          icon={icon}
        />
        <h2 className="h2">{title}</h2>
      </div>
      {children}
    </div>
  )
}

ConfettiCard.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  icon: PropTypes.object,
  iconClassName: PropTypes.string,
  title: PropTypes.string,
}

export default ConfettiCard
